var map = {
	"./$GMUSIC-icon.png": 1980,
	"./BAT-icon.png": 1981,
	"./BTC-icon.png": 1982,
	"./BXC-icon.png": 1983,
	"./CC-icon.png": 656,
	"./DistTest-icon.png": 1984,
	"./ETH-icon.png": 1985,
	"./ETIME-icon.png": 1986,
	"./ETIME[GYRI]-icon.png": 1987,
	"./GALA-icon.png": 1350,
	"./GALA[ETH]-icon.png": 1988,
	"./GALA[GYRI]-icon.png": 1989,
	"./GUSDC-icon.png": 1990,
	"./GUSDT-icon.png": 1991,
	"./GWBTC-icon.png": 1992,
	"./GWETH-icon.png": 1993,
	"./MTRM-icon.png": 1994,
	"./NODETESTCOIN-icon.png": 1995,
	"./SILK-icon.png": 1996,
	"./SILK[GYRI]-icon.png": 1997,
	"./SUPER-icon.png": 1998,
	"./TANK-icon.png": 1999,
	"./TCTESTCOIN-icon.png": 2000,
	"./TEST-icon.png": 2001,
	"./TOWN-icon.png": 2002,
	"./USD-icon.png": 1107,
	"./USDC-icon.png": 2003,
	"./USDT-icon.png": 2004,
	"./WBTC-icon.png": 2005,
	"./WETH-icon.png": 2006,
	"./coinpayments-icon.png": 2007,
	"./mastercard-icon.png": 654,
	"./simplex-icon.png": 1364,
	"./visa-icon.png": 655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 860;